import { Component, OnInit, Input, ViewChild, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalConstants } from '../../../../common/constants/global.constant';
import { CdTimerComponent, TimeInterface } from 'angular-cd-timer';
import { LoginService } from 'src/app/core/routing/services/login/login.service.ts.service';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

@Component({
  selector: 'iposcen-two-fa',
  templateUrl: './two-fa.component.html',
  styleUrls: ['./two-fa.component.scss']
})
export class TwoFAComponent implements OnInit, OnDestroy {

  @Input() fromParent;
  @ViewChild('basicTimer', { static: true }) basicTimer: CdTimerComponent;

  loginhref: string;
  twoFASentForm: FormGroup;
  twoFATextlen: number = 0;
  codeAttemptCount: number = 10;
  verifyBtnTxt: string;
  email: string;
  // modalRef: NgbModalRef;
  modalDiv; string;
  closeText: string;
  closeResult: string;
  private sub: any;
  isOTPExpired: boolean = false;
  isCodeSent: boolean = true;
  wrongCodeTxt: string;
  isWrongCodeAttempt: boolean = false;
  GlobalConst: typeof GlobalConstants;
  finalValue: string ='';

  private timeoutIds: NodeJS.Timeout[] = [];
  private ngUnsubscribe = new Subject<boolean>();

  constructor(private router: Router,
    public route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private loginServicce: LoginService,
    ) { }

  ngOnInit(): void {
    const otpAccess = sessionStorage.getItem('visitedTwoFA') === 'true';

    if (!otpAccess) {
      this.router.navigate(['/login']);
    }
    sessionStorage.setItem('visitedTwoFA', 'false');
    this.email = this.fromParent;
    this.GlobalConst = GlobalConstants;
    this.verifyBtnTxt = GlobalConstants.VERIFY_BTN;
    this.twoFASentForm = this.formBuilder.group({
      verifyCode: new FormControl('', [Validators.required]),
      1:new FormControl (""),
      2:new FormControl (""),
      3:new FormControl (""),
      4:new FormControl (""),
      5:new FormControl (""),
      6:new FormControl (""),
    });
    this.timeoutIds.push(setTimeout(() => {
      this.isCodeSent = false;
    }, 1500));

    this.loginServicce.wrongOTPError$
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(err => {
      this.isWrongCodeAttempt = true;
      this.codeAttemptCount--;
      this.wrongCodeTxt = GlobalConstants.WRONG_CODE_ENTER + this.codeAttemptCount;
      this.verifyBtnTxt = GlobalConstants.VERIFY_BTN;
    })
  }
  verifyBtn() {
    this.verifyBtnTxt = `<span class="spinner-border spinner-border-sm" role="status"></span> ` + GlobalConstants.VERIFYING_BTN;
    this.isWrongCodeAttempt = false;
    setTimeout(() => {
    this.loginServicce.verifyMFACde(this.twoFASentForm.get('verifyCode').value);
    }, 1000)
  }
  onOTPPaste(event) {
    const data = event.clipboardData?.getData('text') || '';
    this.twoFATextlen = data.length;
  }
  onKeyUp(e) {
    e.target.value=isNaN(e.target.value)? '':e.target.value;
    this.finalValue='';
    for (let [k, v] of Object.entries(this.twoFASentForm.value)) {
      if(k.length<2){
        this.finalValue+=v;
      }
    }
    if(e.target.value){
      if(e.code==='ShiftLeft'){
        let id=Number(e.target.id)<2?'1':Number(e.target.id)-1;
        document.getElementById(id.toString())?.focus();
      }
      else{
        document.getElementById((Number(e.target.id)+1).toString())?.focus();
      }
    }
    else{
        document.getElementById(Number(e.target.id).toString())?.focus();
    }
    this.twoFATextlen = this.finalValue.length;
  }
  goBackHome() {
    this.router.navigate(['/']);
  }
  onComplete(data) {
    this.isOTPExpired = true;
  }

  onTick(data: TimeInterface) {
    // this.timerInfo = 'In Progress [' + data.tick_count.toString().padStart(4, '0') + ']';
  }

  onStart(data) {
    console.log('Timer started.');
  }

  doActionBasicTimer(action: String) {
    this.basicTimer.reset();
    this.isOTPExpired = false;
    this.isWrongCodeAttempt = false;
    this.isCodeSent = true;
    this.codeAttemptCount = 10;
    this.twoFASentForm.patchValue({ 'verifyCode': '' });
    this.loginServicce.resendMFACode(this.codeAttemptCount);
    this.timeoutIds.push(setTimeout(() => {
      this.isCodeSent = false;
      this.basicTimer.start();
    }, 5000));
  }

  ngOnDestroy(): void {
    this.timeoutIds.forEach(id => clearTimeout(id));
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}